import { differenceInHours } from "date-fns";
import { getCurrentEpochStartedTimestamp } from "domain/stats";

export function getFormattedFeesDuration() {
  const epochStartedTimestamp = getCurrentEpochStartedTimestamp();

  const now = new Date();
  const epochStartedDate = new Date(epochStartedTimestamp * 1000);
  // Round total hours first, then split, so 2d 23h 40m reads "3d" rather than "2d 24h"
  const totalHours = differenceInHours(now, epochStartedDate, { roundingMethod: "round" });
  const days = Math.floor(totalHours / 24);
  let restHours = totalHours - days * 24;
  if (days === 0) {
    restHours = Math.max(restHours, 1);
  }

  const daysStr = days > 0 ? `${days}d` : "";
  const hoursStr = restHours > 0 ? `${restHours}h` : "";
  return [daysStr, hoursStr].filter(Boolean).join(" ");
}
